import './skills.css'
import data from './data'
import Card from '../../components/Card'

const Skills = () => {
  return (
    <section id="skills">
      <h2>Skills</h2>
      <p>
        My main set of skills are shown below.
      </p>
      <div className="container skills__container" data-aos="fade-up">
        {
          data.map(item => (
            <Card key={item.id} className="skills light">
              <div className="skills__icon">{item.icon}</div>
              <div className="skills__details">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </Card>
          ))
        }
      </div>
    </section>
  )
}

export default Skills